<template>
    <div :style="textStyle" class="text-container text-view" v-html="getHtml()"></div>
</template>

<script>
import { resolveMargin, resolvePadding } from "../utils/style"

export default {
    props: {
        settings: {
            type: Object,
            default: () => {}
        }
    },
    name: "WidgetTextInline",
    computed: {
        textStyle() {
            return {
                minWidth: "50px",
                ...this.resolveStyle(
                    {
                        ...resolvePadding(this.settings.desktop.padding),
                        ...resolveMargin(this.settings.desktop.margin)
                    },
                    {
                        ...resolvePadding(this.settings.mobile.padding),
                        ...resolveMargin(this.settings.mobile.margin)
                    }
                )
            }
        }
    },
    methods: {
        getHtml() {
            return this.settings.general.text
                .replaceAll("&quot;", "'")
                .replaceAll('<html-component open="true" value="', "")
                .replaceAll('<html-component open="false" value="', "")
                .replaceAll('"></html-component>', "")
                .replaceAll("\n")
        }
    }
}
</script>
